import { all, put, getContext, takeLatest } from 'redux-saga/effects';

import { Logger } from 'utils/Logger';

import { GET_CONFIGURATION_REQUEST } from './types';

import { getConfigurationSuccess, getConfigurationFailure } from './reducer';

const logger = new Logger('Saga:Dashboard');

export function* getDashboardConfiguration() {
  const authApiService = yield getContext('authApiService');
  const routerService = yield getContext('routerService');

  try {
    const response = yield authApiService.get(
      routerService.generate('api.dashboard_configuration'),
    );

    logger.info('Got new dashboard configuration');
    yield put(getConfigurationSuccess(response.data));
  } catch (error) {
    logger.error(error);
    yield put(getConfigurationFailure(error));
  }
}

export default function* userSaga() {
  return yield all([takeLatest(GET_CONFIGURATION_REQUEST, getDashboardConfiguration)]);
}
